<style lang="less">
    .lendRecord{
        border: 1px solid #d7dde4;
        background: #efefef;
        height: 100%;
        position: relative;
        .head{
            height: 46px;
            padding-top: 10px;
            margin-bottom: 20px;
            h1{
                display: inline;
                margin-left: 20px;
                };
            .searchArea{
                display: inline-block;
                margin-left: 20px;
            }
        }
        .layout-breadcrumb{
            padding: 10px 15px 0px ;
            /*border-bottom: 1px solid #e3e3e3;*/
        }
        .layout-content{
            min-height: 80vh;
            margin: 15px;
            overflow: hidden;
            background: #fff;
            border-radius: 4px;
        }
        .layout-content-main{
            padding: 10px;
        }
        .table th{
            background-color: #00c0ff;
            color: #fff;
        }
        .footer{
            margin-top: 10px;
            width: 100%;
            height: 46px;
        }

    }
    .ivu-table .demo-table-info-row td{
        color: #f50807;
    }



</style>
<template>
    <div class="lendRecord">
        <Row>
            <i-col span="24">
                <div class="layout-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem >就餐管理</BreadcrumbItem>
                        <BreadcrumbItem >就餐设置</BreadcrumbItem>
                    </Breadcrumb>
                </div>
                <div class="layout-content">
                    <div class="layout-content-main">
                        <div class="head">
                            <h1 >就餐设置</h1>
                            <!--<div class="searchArea">-->
                                <!--起始日期:-->
                                <!--<DatePicker  type="date" placeholder="请选择开始时间" v-model="startDate" formate="yyyy-MM-dd" @on-change="setDate('startDate',$event)"></DatePicker>-->
                                <!--结束日期:-->
                                <!--<DatePicker type="date" placeholder="请选择结束时间" v-model="endDate" formate="yyyy-MM-dd" @on-change="setDate('endDate',$event)"></DatePicker>-->
                                <!--<Button type="primary" @click="search">查询</Button>-->

                            <!--</div>-->
                        </div>


                    </div>
                </div>

            </i-col>

        </Row>
    </div>

</template>

<script>
    export default {
        data () {
            return {
                loadDataUrl:'manage/waterrec/weixin_list',
                percent: 0,
                username:'',
                startDate:'',
                endDate:'',
                recordPage: {
                    current: 1,
                    pageSize: 20,
                    total: 0
                },
                totalSize:0,
                pageSize:14,
                page:1,
                dataSourceList:[],
                columns1: [
//                    {
//                        title: '用友系统卡片编号',
//                        key: 'DataTime',
//                        align: 'center'
//                    },
                    {
                        title: '固定资产名称',
                        key: 'name',

                        align: 'center'
                    },
                    {
                        title: '借出部门',
                        key: 'lend_department',
                        align: 'center'
                    },
                    {
                        title: '借出人',
                        key: 'lender',
                        align: 'center'
                    },
                    {
                        title: '借出单位',
                        key: 'lend_company',
                        align: 'center',
                    },
                    {
                        title: '借出时间',
                        key: 'lend_time',
                        align: 'center'
                    },
                    {
                        title: '归还时间',
                        key: 'return_time',
                        align: 'center'
                    },
                    {
                        title: '备注',
                        key: 'remarks',
                        align: 'center'
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                        let rowData = params.row;
                            if(rowData.return_time!=''){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            size: 'small',
                                            disabled:true
                                        },
                                        style: {
                                            marginRight: '5px',
                                        },
                                    }, '已归还'),
                                ]);
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                            this.sendBack(params.index)
                                    }
                            }
                            }, '确定归还'),
                            ]);
                            }

                        }
                    },

                ],
            }

        },
        methods: {
            //渲染未归还行颜色
            rowClassName (row,index) {
                var that =this;
                for(var i=0;i<this.dataSourceList.length;i++){
                    if(that.dataSourceList[i].return_time==""&& index == i){
                        return 'demo-table-info-row';
                    }
                }
            },

            //设置日期
            setDate:function (type,value) {
                switch (type){
                    case 'startDate':
                        this.startDate = value ;
                        console.log(this.startDate);
                        break;
                    case 'endDate':
                        if(value == ''){
                            this.endDate = value;
                        }else {
                            let date = new Date(value);
                            date.setDate(date.getDate());
                            this.endDate = date.format("yyyy-MM-dd");
                            console.log(this.endDate);
                        }
                        break;
                }
            },
            //查询
            search:function () {
                var that=this;
                var params = {};
                this.startDate=new Date(this.startDate).format('yyyy-MM-dd');
                this.endDate=new Date(this.endDate).format('yyyy-MM-dd');
                params.data = {
                    "searchValue":{DataTime:that.startDate+' 00:00:00 |#|'+that.endDate+' 23:59:59'},
                    "order":{"DataTime":-1},
                    pageSize:this.pageSize,
                    page:1
                };
                if(this.startDate=='NaN-aN-aN'&&this.endDate=='NaN-aN-aN'){
                    params.data.searchValue={}
                }
                params.token = this.getKey('token');
                params.url = this.loadDataUrl;
                console.log(params.data);
                params.success = function(res) {
                    console.log(res);
                    that.$Loading.finish();
                    that.totalSize=res.result.totalSize;
                    that.page=res.result.page;
                    that.dataSourceList = res.result.result;
                }
                this.ajaxPost(params);
            },
            //加载数据
            loadData: function(page){
                var that = this;
                var params = {};
                this.startDate=new Date(this.startDate).format('yyyy-MM-dd');
                this.endDate=new Date(this.endDate).format('yyyy-MM-dd');
//                page = page == '' || page == undefined?this.page:page;
                params.data = {
//                    "searchValue":{DataTime:that.startDate+' 00:00:00 |#|'+that.endDate+' 23:59:59'},
//                    "order":{"DataTime":-1},
//                    pageSize:this.pageSize,
//                    page:page
                };
//                if(page === undefined || page === "" || isNaN(page)){
//                    params.data.page = 1;
//                }else{
//                    params.data.page = page;
//                }
//                if(this.startDate=='NaN-aN-aN'&&this.endDate=='NaN-aN-aN'){
//                    params.data.searchValue={}
//                }
                params.token = this.getKey('token');
                params.url = '/sys/lendrecord/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
//                    that.totalSize=res.result.totalSize;
//                    that.page=res.result.page;
                    that.dataSourceList = res.data.result.result;

                }
                this.ajaxPost(params);

            },
            sendBack:function (index) {
                var that = this;
                var params = {};
                this.dataSourceList[index].return_time=new Date().format('yyyy-MM-dd');
                params.data = this.dataSourceList[index];
                params.token = this.getKey('token');
                params.url = '/sys/lendrecord/edit';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.$Notice.success({
                        title: '归还成功'
                    });
                    that.loadData()
//                    that.totalSize=res.result.totalSize;
//                    that.page=res.result.page;

                }
                this.ajaxPost(params);
            },
            changePage: function(page) {
                this.loadData(page);
            },
        },
        mounted: function () {
//            console.log(555);
//            console.log(888);
//            this.endDate=new Date().format('yyyy-MM-dd');
//            this.startDate=new Date(new Date(this.endDate).getTime()-24*60*60*1000).format('yyyy-MM-dd');
            this.loadData()

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/dinnerMana/mealSetting.vue